import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';

import { Type } from 'app/constants/TourPoints';
import { useMediator } from '../useMediator';

import * as mapStatus from '../../../../HOGs/rxBehaviorSubject';

let isMapBlocked = false;
let subscription = null;
let listActions = {};

export const trigger = () => {
  subscription = mapStatus.subscribe(({ status }) => {
    isMapBlocked = status;
  });
  const [setMediator, destroyMediator] = useMediator();

  const notify = (key, obj) => {
    if (isMapBlocked) {
      const { customId = '', pointId = '' } = obj;
      const uniqueKey = customId || pointId || '';
      if (
        key !== way.DRIVE_BUILDER_POINT_UPDATE &&
        key !== way.DRIVE_MAP_LAUNCH_TOUR_CORRECTION_POINT_LIST
      )
        listActions[`${key}_${uniqueKey}`] = { key, obj };
    } else {
      if (Object.keys(listActions).length > 0) {
        Object.keys(listActions).forEach((unique) => {
          console.log('11111111111111111111', unique, listActions);
          const { key, obj } = listActions[unique]; // eslint-disable-line
          publish(key, obj);
        });
        listActions = {};
      }
      publish(key, obj);
    }
  };

  const showPointOnMap = (point, isLoading = false, mapZoom = 0) => {
    const params = {
      customId: point.id,
      point,
      isLoading,
      isLast: point.type === Type.END,
      mapZoom,
    };
    notify(way.DRIVE_BUILDER_POINT_CREATE, params);
  };
  const delyList = {};
  const upPointOnMap = ({ isLastVia, ...point }) => {
    const { id } = point;
    if (delyList[id]) {
      clearTimeout(delyList[id]);
    }
    delyList[id] = setTimeout(() => {
      notify(way.DRIVE_BUILDER_POINT_UPDATE, {
        customId: point.id,
        point,
        isLastVia,
      });
    }, 400);
  };
  const upPartPointDataOnMapById = (obj) => {
    notify(way.DRIVE_BUILDER_PART_POINT_DATA_UPDATE, { ...obj });
  };
  const showPolyStrOnMap = (obj) => notify(way.DRIVE_MAP_CHANGE_POLY, obj);
  const removeTourPointOnMap = (customId) =>
    notify(way.DRIVE_MAP_POINT_REMOVE_ONLY_ON_MAP, { customId });
  const cleanData = (isNeedRemovePoly = true) => {
    notify(way.DRIVE_BUILDER_DATA_CLEAN, {});
    if (isNeedRemovePoly) notify(way.DRIVE_BUILDER_CLEAN_POLYLINES, {});
  };

  const destroy = () => {
    notify(way.DRIVE_BUILDER_DATA_CLEAN, {});
    destroyMediator();
    if (subscription) {
      subscription.unsubscribe();
    }
  };

  const updatePolyHandlers = (isEdit, pointId) =>
    notify(way.DRIVE_MAP_UP_POLY_HANDLERS, { isEdit, pointId });

  const showPartPointOnMap = (point) => {
    const params = {
      customId: point.id,
      point,
      isLast: point.isLast && point.type === Type.END,
    };
    notify(way.DRIVE_BUILDER_PART_POINT_CREATE, params);
  };

  const selectePartPoly = (partId) =>
    notify(way.DRIVE_MAP_STATIC_PART_POLY_SELECT, { partId });

  const selectePartFirstPoint = (customId) =>
    notify(way.DRIVE_MAP_STATIC_ACTIVE_POINT_ON_MAP, { customId });

  const selectePartLastPoint = (customId) =>
    notify(way.DRIVE_MAP_STATIC_ACTIVE_LAST_POINT_ON_MAP, { customId });

  const moveMapToLocation = (latLng) =>
    notify(way.BUILDER_MAP_FLY_TO_LOCATION, { latLng });

  const launchTourCorrection = (data) =>
    notify(way.DRIVE_MAP_LAUNCH_TOUR_CORRECTION_POINT_LIST, data);

  const updateWrongRouteMarkerValue = (data) =>
    notify(way.DRIVE_MAP_UPDATE_WRONG_ROUTE_MARKER_VALUE, data);

  const entireTour = (isOnlyCentering = false) =>
    notify(way.DRIVE_MAP_CENTERING, { isOnlyCentering });

  const changePointPolyOnMap = (obj) =>
    notify(way.DRIVE_MAP_CHANGE_POINT_POLY, { ...obj });

  const movePointPoly = (obj) =>
    publish(way.DRIVE_MAP_MOVE_POINT_POLY, { ...obj });

  return Object.freeze({
    setMediator,
    showPointOnMap,
    showPolyStrOnMap,
    removeTourPointOnMap,
    showPartPointOnMap,
    upPointOnMap,
    cleanData,
    updatePolyHandlers,
    selectePartPoly,
    destroy,
    selectePartFirstPoint,
    selectePartLastPoint,
    moveMapToLocation,
    launchTourCorrection,
    updateWrongRouteMarkerValue,
    entireTour,
    changePointPolyOnMap,
    movePointPoly,
    upPartPointDataOnMapById,
  });
};
